'use strict';

require('./paymentMethod');
require('./user');